import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private SupplierOffer Types */
import {
  _SupplierOfferDeclines
} from '../namespace-helper'

export default {
  namespaced: true,
  state: {
    supplierOfferDeclines: [],
    supplierOfferDeclinesLoading: false
  },
  mutations: {
    [_SupplierOfferDeclines.mutations.setSupplierOfferDeclines] (state, payload) {
      state.supplierOfferDeclines = payload
    },
    [_SupplierOfferDeclines.mutations.setLoadSupplierOfferDeclines] (state, payload) {
      state.supplierOfferDeclinesLoading = payload
    }
  },
  actions: {
    [_SupplierOfferDeclines.actions.saveSupplierOfferDeclines] (context, payload) {
      context.commit(_SupplierOfferDeclines.mutations.setLoadSupplierOfferDeclines, true)

      const data = JSON.stringify(payload)

      if (payload.id === 0) {
        var url = API_URL + '/api/v1/supplierOfferDeclines'

        return new Promise((resolve, reject) => {
          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            context.commit(_SupplierOfferDeclines.mutations.setLoadSupplierOfferDeclines, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            context.commit(_SupplierOfferDeclines.mutations.setLoadSupplierOfferDeclines, false)
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        })
      } else {
        url = API_URL + '/api/v1/supplierOfferDeclines/' + payload.id

        return new Promise((resolve, reject) => {
          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            context.commit(_SupplierOfferDeclines.mutations.setLoadSupplierOfferDeclines, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            context.commit(_SupplierOfferDeclines.mutations.setLoadSupplierOfferDeclines, false)
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        })
      }
    },
    [_SupplierOfferDeclines.actions.loadSupplierOfferDeclinesByInquiryID] (context, payload) {
      context.commit(_SupplierOfferDeclines.mutations.setLoadSupplierOfferDeclines, true)

      var url = API_URL + '/api/v1/supplierOfferDeclines/inquiry/' + payload.id

      axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        context.commit(_SupplierOfferDeclines.mutations.setLoadSupplierOfferDeclines, false)
        ErrorHandler.clear(store)
        context.commit(_SupplierOfferDeclines.mutations.setSupplierOfferDeclines, r.data.data)
      }, function (err) {
        context.commit(_SupplierOfferDeclines.mutations.setLoadSupplierOfferDeclines, false)
        context.commit(_SupplierOfferDeclines.mutations.setSupplierOfferDeclines, [])
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_SupplierOfferDeclines.actions.removeSupplierOfferDecline] (context, payload) {
      context.commit(_SupplierOfferDeclines.mutations.setLoadSupplierOfferDeclines, true)

      var url = API_URL + '/api/v1/supplierOfferDeclines/' + payload
      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_SupplierOfferDeclines.mutations.setLoadSupplierOfferDeclines, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          context.commit(_SupplierOfferDeclines.mutations.setLoadSupplierOfferDeclines, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOfferDeclines.actions.setSupplierOfferDeclines] (context, payload) {
      context.commit(_SupplierOfferDeclines.mutations.setSupplierOfferDeclines, payload)
    },
    [_SupplierOfferDeclines.actions.resetState] (context, payload) {
      context.commit(_SupplierOfferDeclines.mutations.setSupplierOfferDeclines, [])
    }

  },
  getters: {
    [_SupplierOfferDeclines.getters.getSupplierOfferDeclines] (state) {
      return state.supplierOfferDeclines
    },
    [_SupplierOfferDeclines.getters.getLoadingSupplierOfferDeclines] (state) {
      return state.supplierOfferDeclinesLoading
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/SupplierOfferDeclines/supplierOffersDeclines.js